import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/participant_buffer`;

export const ACTION_TYPES = {
  FETCH_BUFFER_LIST: 'buffer/FETCH_BUFFER_LIST',
  DELETE_BUFFER: 'manual/DELETE_BUFFER',
  RESET: 'buffer/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [],
  entity: {}, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const participantbufferReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_BUFFER_LIST):
      return {
        ...state,
        errorMessage: null,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.DELETE_BUFFER):
        return {
          ...state,
          errorMessage: null,
          updateSuccess: false,
          updating: true,
        };
    case FAILURE(ACTION_TYPES.FETCH_BUFFER_LIST):
    case FAILURE(ACTION_TYPES.DELETE_BUFFER):
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_BUFFER_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.DELETE_BUFFER):
        return {
          ...state,
          updating: false,
          updateSuccess: true,
          entity: {},
        };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default participantbufferReducer;

// ACTIONS
export const getEntities = (idclass, page, size, sort) => ({
  type: ACTION_TYPES.FETCH_BUFFER_LIST,
  payload: axios.get(`${apiUrl}/classroom/${idclass}`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const SearchBufferByNip = (condition, idclass, page, size, sort) => ({
  type: ACTION_TYPES.FETCH_BUFFER_LIST,
  payload: axios.get(`${apiUrl}/search?q=${condition},classroom.id:${idclass}`, {
    params: {
      page: undefined || page,
      sort: undefined || sort,
      size: undefined || size
    },
  })
});

export const deleteEntity = (id, idclass, pagination, size, sortTable, keyStatus, condition) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_BUFFER,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { successMessage: `Berhasil hapus!` },
  });
  if(keyStatus === true){
    dispatch(SearchBufferByNip(condition, idclass, pagination-1, size, sortTable));
  }else{
    dispatch(getEntities(idclass, pagination-1, size, sortTable));
  }
  return result;
};

export const deleteListUserInvitation = (payload, idclass, pagination, size, sortTable, keyStatus, condition) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_BUFFER,
    payload: axios.post(`${apiUrl}/bulk-kick-user`, payload),
    meta: { successMessage: `Berhasil Hapus!` },
  });
  if(keyStatus === true){
    dispatch(SearchBufferByNip(condition, idclass, pagination-1, size, sortTable));
  }else{
    dispatch(getEntities(idclass, pagination-1, size, sortTable));
  }
  
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
